import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote, MapPin, Stamp } from "lucide-react";
import api, { imgSrc } from "../lib/api";
import { SectionHeading, stagger, fadeUp, Reveal } from "../lib/motion";
import { t } from "../i18n";

const StoriesSection = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <section id="success-stories" data-testid="success-stories-section" className="relative py-24 lg:py-32 bg-navy overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("stories.eyebrow")}
          title={t("stories.title")}
          description={t("stories.desc")}
          testid="stories-heading"
        />
        {items && items.length > 0 ? (
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {items.map((t) => (
              <motion.div key={t.id} variants={fadeUp} data-testid={`story-card-${t.id}`} className="glass-card card-lift rounded-2xl p-8 flex flex-col">
                <Quote className="h-6 w-6 text-gold mb-5" />
                <p className="text-sm text-slate-300 leading-relaxed flex-1">{t.review}</p>
                <div className="mt-7 flex items-center gap-4">
                  {t.photo ? (
                    <img src={imgSrc(t.photo)} alt={t.name} className="h-12 w-12 rounded-full object-cover border border-gold/40" />
                  ) : (
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15 border border-gold/40 font-display font-bold text-gold">
                      {t.name.charAt(0)}
                    </span>
                  )}
                  <div>
                    <p className="font-display font-bold text-white text-sm">{t.name}</p>
                    <p className="text-xs text-slate-400 flex items-center gap-1.5 mt-0.5">
                      <MapPin className="h-3 w-3 text-gold" /> {t.destination}
                      <span className="text-slate-600">·</span> {t.visa_category}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        ) : items && items.length === 0 ? (
          <Reveal className="max-w-2xl mx-auto">
            <div className="rounded-2xl border border-dashed border-gold/40 bg-gold/[0.03] p-12 text-center" data-testid="stories-placeholder">
              <Stamp className="h-10 w-10 text-gold mx-auto mb-5" />
              <h3 className="font-display text-xl font-bold text-white mb-3">{t("stories.placeholderTitle")}</h3>
              <p className="text-sm text-slate-400 leading-relaxed max-w-md mx-auto">
                {t("stories.placeholderText")}
              </p>
            </div>
          </Reveal>
        ) : (
          <div className="h-40" />
        )}
      </div>
    </section>
  );
};

export default StoriesSection;
